import { AccordionTheme } from '@/components/Accordion/theme';
import { Icon as StandaloneIcon } from '@/components/Icon';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: AccordionTheme });

const Base = $({ as: 'div', slot: 'base' });
const Toggle = $({ as: 'div', slot: 'toggle' });
const Group = $({ as: 'div', slot: 'group' });
const Content = $({ as: 'div', slot: 'content' });
const Headline = $({ as: 'span', slot: 'headline' });
const Icon = GenericSlot({ as: StandaloneIcon, theme: AccordionTheme.Icon });

export const Accordion = Object.assign(Base, {
  Toggle,
  Group,
  Content,
  Headline,
  Icon,
});
